// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__eQRB4","col":"styles_col__3Qidu"};